import LmsFormGenerator, { BCFormController } from "../ui/LmsFormGenerator";
import { useParseRouteActions,useFetchData } from "../../../helpers/GlobalHelper";
import LmsTable from "../ui/LmsTable";
import { IdProps } from "../../interfaces/Global";

const LmsReportsTable = () => {
  const actionsButtons = ["add", "edit", "remove", "export"];
  return <LmsTable
    actionButtons={actionsButtons}
    apiSuffix="menu/credit-request"
    deleteSuffix="menu/credit-request"
  />;
};

const addLmsCreditRequestFormFields = (myForm: BCFormController) => {
  myForm.addCenteredGroup([ 
    myForm.getDropdownField("Organization Contact", "orgs/list-organization-contacts", { name: "organizationContactId", required: true }),// TODO: confirmed with Antonio, endpoint is pending
    myForm.getInputField("Credit Score", { name: "creditScore" }),
  ]);

  myForm.addCenteredGroup([myForm.getInputField("Completion Status", { name: "completionStatus", required: true, width: 3 })]);
  myForm.addCenteredGroup([myForm.getTextareaField("Error Message", { name: "errorMessage" })]);
  myForm.addCenteredGroup([myForm.getTextareaField("Request Object1", { name: "requestObject1" })]);
  myForm.addCenteredGroup([myForm.getTextareaField("Response Object1", { name: "responseObject1" })]);
  myForm.addCenteredGroup([myForm.getTextareaField("Request Object2", { name: "requestObject2" })]);
  myForm.addCenteredGroup([myForm.getTextareaField("Response Object2", { name: "responseObject2" })]); 
  return myForm;
};

const AddLmsCreditRequestForm = () => {
  const myForm = addLmsCreditRequestFormFields(new BCFormController({}, { submitSuffix: "menu/credit-request", submitMethod: "POST" }));
  const formActions = ["save-new","save-continue","save-close","close"];
  return (<LmsFormGenerator myForm={myForm} actions={formActions} />);
};

const EditLmsCreditRequestForm = ({ id = "" }: IdProps) => {
  const [{ data = {}, isLoading, error }] = useFetchData(`menu/credit-request/${id}`);
  const myForm = addLmsCreditRequestFormFields(new BCFormController(data, { 
    initIsDisabled: true, 
    submitSuffix: "menu/credit-request", 
    submitMethod: "PUT",
    deleteSuffix: "menu/credit-request",
  }));
  const formActions = ["save", "save-close", "delete", "close"];
  return (<LmsFormGenerator myForm={myForm} isLoading={isLoading} error={error} actions={formActions} />);
};

const LmsNewMenusCreditRequest = ({ params = {}, history }) => {
  const allowedActions = ["add"];
  const { isAdd, isEdit, isMainPage, isActionAllowed, id } = useParseRouteActions(params,allowedActions);  
  if (!isActionAllowed) {
    history.goBack();
  }

  return <>
    {isMainPage && <LmsReportsTable />}
    {isAdd && <AddLmsCreditRequestForm />}
    {isEdit && <EditLmsCreditRequestForm id={id} />}
  </>;
};

export default LmsNewMenusCreditRequest;